import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { Logo } from "@/components/Logo"
import { IconButtons } from "@/components/navigation/IconButtons"
import { NavigationTabs } from "@/components/navigation/NavigationTabs"
import { UserDropdown } from "@/components/navigation/UserDropdown"
import { Button } from "@/components/ui/button"

interface AppHeaderProps {
  onSearchOpen: () => void
  onNotificationsOpen: (open: boolean) => void
  onCreateOpen: () => void
}

export function AppHeader({ onSearchOpen, onNotificationsOpen, onCreateOpen }: AppHeaderProps) {
  const { t } = useTranslation("dashboard")
  const [isScrolled, setIsScrolled] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 25)
    }

    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  return (
    <header
      className={`absolute -top-1 left-0 right-0 z-50 transition-colors duration-200 ${
        isScrolled ? "bg-black/20 backdrop-blur-md" : "bg-transparent"
      }`}
    >
      <div className="px-5 lg:px-17.5">
        <div className="relative h-full flex items-center justify-between py-5 lg:py-0">
          <div className="cursor-pointer" onClick={() => navigate("/")}>
            <Logo />
          </div>

          <div className="flex-1 flex justify-center ms-20">
            <NavigationTabs />
          </div>

          <div className="flex items-center gap-3">
            <div className="hidden lg:block">
              <IconButtons onSearchOpen={onSearchOpen} />
            </div>

            <div className="hidden lg:block">
              <Button variant="primary" size="sm" className="px-8 uppercase" onClick={onCreateOpen}>
                {t("create.button")}
              </Button>
            </div>

            <div className="hidden lg:block">
              <UserDropdown isMobile={false} />
            </div>

            <div className="lg:hidden">
              <UserDropdown
                isMobile={true}
                onNotificationsOpenChange={onNotificationsOpen}
                onSearchOpen={onSearchOpen}
              />
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}
